import { useEffect, useRef, useState } from 'react';
import { Designer } from '@pdfme/ui';
import { barcodes, checkbox, date, dateTime, ellipse, image, line, multiVariableText, radioGroup, rectangle, select, svg, table, text, time } from '@pdfme/schemas';
import { documentTemplateService } from '../../services/document-template';
import { t } from 'i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const plugins = {
  Table: table,
  text: text, 'QR Code': barcodes.qrcode,
  image, svg, line, dateTime, date, time, select, radioGroup, checkbox, ellipse, rectangle, multiVariableText
}

let defaultTemplate = {
  schemas: [],
  basePdf: '/sample.pdf',
};
const DocumentTemplateDefinition = () => {
  const navigate = useNavigate();
  const params = useParams();
  const templateId = params.id;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const designerRef = useRef<Designer | null>(null);
  const [name, setName] = useState('');

  useEffect(() => {
    (async function () {

      if (templateId) {
        const result = await documentTemplateService.getAsync(templateId);
        const data = result.data;
        setName(data.name);
        if (containerRef.current) {
          designerRef.current = new Designer({
            domContainer: containerRef.current,
            template: JSON.parse(data.template),
            plugins: plugins
          });
        }
      }
      else {
        if (containerRef.current) {
          designerRef.current = new Designer({
            domContainer: containerRef.current,
            template: defaultTemplate,
            plugins: plugins
          });
        }
      }
    })();

  }, []);

  const handleSave = async () => {
    const template = JSON.stringify(designerRef.current?.getTemplate());
    const data = { name: name, template: template };
    if (templateId) {
      documentTemplateService.updateAsync(templateId, data)
      .then(async () => {
        toast.success(t("saved_changes"));
      }).catch((error) => {
          toast.error(error.response.data.message);
      })
    }
    else {
      documentTemplateService.createAsync(data).then(async () => {
        toast.success(t("saved_changes"));
        navigate(`/admin/document-template-list`)
      }).catch((error) => {
        toast.error(error.response.data.message);
      })
    }

  }
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ marginBottom: '20px' }}>
        <label htmlFor="name">{t('template_name')}:*</label><br />
        <input
          type="text"
          id="name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{
            width: '15%',
            padding: '8px 12px',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
            outline: 'none',
            marginTop: '4px'
          }}
        />
        <button
          style={{
            float: 'right',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
          onClick={handleSave}
        >
          {t('save')}
        </button>
      </div>
      <div ref={containerRef} style={{ width: '100%', height: '600px', marginBottom: '20px' }} />
    </div>
  );


};

export default DocumentTemplateDefinition;
